import { useCallback, useEffect } from 'react';
import { getNews } from '../store/ducks/news/actions';
import _ from 'lodash';
import { useDispatch } from 'react-redux';
import { NewsSelectorOmitType } from '../store/ducks/newsOne/types';
import { useHistory } from 'react-router-dom';

export function useScroll(
    news: NewsSelectorOmitType[],
    page: number,
    limit: number,
    percentHeight: number
) {
    const dispatch = useDispatch();
    const { location } = useHistory();
    const recalculateProgressCallback = useCallback(
        function recalculateProgress() {
            const viewportHeight = Math.round(
                window.innerHeight - (window.innerHeight * percentHeight) / 100
            );

            const element = document.elementFromPoint(10, viewportHeight)
                .parentNode as HTMLElement;

            if (element && element.dataset.slug) {
                window.history.replaceState(
                    '',
                    '',
                    `/news/${element.dataset.slug}`
                );
                // if (window.ym) {
                //     const ym = window.ym;
                //     ym(87891507, 'hit', location.pathname);
                // }
            }
            //
            if (
                news.length &&
                element.dataset.id === news[news.length - 1].id.toString()
            ) {
                dispatch(getNews({ limit: limit, page: page + 1 }));
            }
        },
        [news.length]
    );

    useEffect(() => {
        const optimizedHandler = _.throttle(recalculateProgressCallback, 500);

        window.addEventListener('scroll', optimizedHandler);
        return () => {
            window.removeEventListener('scroll', optimizedHandler);
        };
    }, [news.length, recalculateProgressCallback]);
}
